/**
 * Custom Chip component based on Vuexy design.
 * Provides consistent styling and round variant support.
 */

// MUI Imports
import MuiChip from '@mui/material/Chip';
import { styled } from '@mui/material';
import type { ChipProps } from '@mui/material/Chip';

/**
 * Custom Chip props with round variant support
 */
export type CustomChipProps = ChipProps & {
  round?: 'true' | 'false';
};

const Chip = styled(MuiChip)<CustomChipProps>(({ round }) => {
  return {
    ...(round === 'true' && {
      borderRadius: 500,
    }),
  };
});

/**
 * Custom Chip component with Vuexy styling.
 * @param props - Chip props with custom options
 */
const CustomChip = (props: CustomChipProps) => <Chip {...props} />;

export default CustomChip;
